import React, { PureComponent } from 'react'
import { Col, Container, Row } from '../../../../Shared/Grid'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import Button from '../../../../Shared/Form/Button'
import RoomForm from '../RoomForm'
import { apiV2ErrorCodes, createRoom } from '../../../../../api'
import Loader from '../../../../Shared/Loader'
import Alert from '../../../../Shared/Alert'
import { isRoomSaveable, sanitizeRoomDetails } from '../common'
import activityTrackingService from '../../../../../services/activityTrackingService'
import { trackingEvent } from '../../../../../constants'
import PageHead from '../../../../Shared/PageHead'

class CreateRoom extends PureComponent {
  state = {
    room: undefined,
    loading: false,
    error: null,
    formIsValid: true,
  }

  abortController = null

  componentWillUnmount () {
    if (this.abortController !== null) {
      this.abortController.abort()
    }
  }

  onRoomChange = (room, formIsValid) => {
    room.giataId = this.props.giataId
    this.setState({ room, formIsValid })
  }

  onCreateClick = () => {
    if (this.abortController !== null) {
      this.abortController.abort()
    }
    activityTrackingService.trackEvent(trackingEvent.createRoom, {
      giataId: this.props.giataId,
    })
    this.abortController = new AbortController()
    const room = Object.assign({}, this.state.room)
    room.details = sanitizeRoomDetails(room.details)
    this.setState({ loading: true, error: null }, () => {
      const { fetchPromise } = createRoom(this.props.giataId, room, this.abortController)
      fetchPromise.then(async (response) => {
        if (response.status >= 200 && response.status < 300) {
          this.setState({ loading: false }, async () => {
            this.props.onRoomCreated(await response.json())
          })
        } else {
          let message = 'Error occurred'
          const json = await response.json()
          if (json.hasOwnProperty('errorCode') && json.errorCode === apiV2ErrorCodes.ROOM_CODE_ALREADY_EXISTS) {
            message = json.error
          }
          this.setState({ loading: false, error: message })
        }
      }).catch((e) => {
        console.error(e)
        if (this.abortController.signal.aborted) {
          return
        }
        this.setState({ loading: false, error: 'Error occurred' })
      })
    })
  }

  render () {
    const { t } = this.props
    return (
      <Container fluid gutterWidth={5}>
        {this.state.loading && <Loader size={32}/>}
        <Row>
          <Col xs={12}>
            <PageHead title={t('CREATE_ROOM')}/>
          </Col>
        </Row>
        {this.state.error && <Alert type={'danger'}>{this.state.error}</Alert>}
        <RoomForm room={this.state.room} onChange={this.onRoomChange} roomAttributes={this.props.roomAttributes}/>
        <Row>
          <Col xs={12}>
            <br/>
            <br/>
            <br/>
            <Button
              style={{ marginLeft: 16, textTransform: 'capitalize' }}
              align="right"
              onClick={this.onCreateClick}
              disabled={!this.state.formIsValid || !isRoomSaveable(this.state.room)}
              variant="primary"
            >
              {t('CREATE_ROOM')}
            </Button>
            <Button align="right" onClick={this.props.onCancel} variant="secondary">{t('BUTTON_CANCEL')}</Button>
          </Col>
        </Row>
      </Container>
    )
  }
}

CreateRoom.propTypes = {
  giataId: PropTypes.number.isRequired,
  roomAttributes: PropTypes.object.isRequired,
  onCancel: PropTypes.func.isRequired,
  onRoomCreated: PropTypes.func.isRequired,
}

export default withTranslation()(CreateRoom)
